import { useState, useEffect } from "react";

import axios from "axios";

//auth
import {
  useAuth
} from "../providers/auth";

//react-router-dom
import {
  useNavigate
} from "react-router-dom";

import openToast from "../utils/sweetAlert";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000000
});

const useAxiosFunction = () => {
  //react-router-dom
  const navigate = useNavigate();

  //auth
  const {
    user,
    setUser
  } = useAuth();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState([]);
  const [controller, setController] = useState(new AbortController);

  const axiosFetch = async (config) => {
    setError("");

    try {
      setError("");
      setLoading(true);

      const ctrl = new AbortController();
      setController(ctrl);

      const options = {
        url: config.url,
        method: config.method.toLowerCase(),
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": "Bearer " + user.token
        },
        signal: ctrl.signal,
        data: config.data
      }

      const res = await axiosInstance(options);

      setResponse(res.data);

      if(res.data?.error === true && res.data?.message) {
        setError(res.data.message);
        openToast("error", "Ocorreu um erro", res.data.message);
      }

      if(res.data?.error === false && res.data?.message) {
        openToast("success", "Sucesso", res.data.message);
      }

      if(res.data?.error === false && config.redirect_to) {
        navigate(config.redirect_to);
      }

    } catch (error) {

      if (axios.isCancel(error)) {
        return;
      }

      if (error.response) {
        if (error.response.status === 401) {
          setUser({ id: "", name: "", token: "" });
          localStorage.removeItem("user");
          navigate("/", { replace: true });

          openToast("info", "Atenção", error.response.data.message);
        } else {
          const message = error.response.data?.message || "Não foi possível realizar a solicitação.";
          openToast("error", "Ocorreu um erro", message);
          setError(message);
        }
      } else {
        openToast("error", "Ocorreu um erro", error.message || "Não foi possível realizar a solicitação.");
        setError(error.message);
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    // useEffect clanup function
    return () => controller && controller.abort();
  }, [controller]);

  return [response, setResponse, loading, error, axiosFetch];
}

export default useAxiosFunction;
